// src/features/tidsregistering/hooks/useOverenskomster.js
import { useState, useCallback } from 'react';
import { overenskomsterAPI } from '../services/overenskomster';
import { useApi } from '../../../hooks/api/useApi';

export function useOverenskomster() {
  const [overenskomst, setOverenskomst] = useState(null);
  const [overenskomster, setOverenskomster] = useState([]);
  const { loading, error, execute, clearError } = useApi();

  const fetchOverenskomst = useCallback(async (overenskomstId) => {
    const result = await execute(() => overenskomsterAPI.getOverenskomst(overenskomstId));
    if (result.success) setOverenskomst(result.data ?? null);
    return result;
  }, [execute]);

  const fetchForDepartment = useCallback(async () => {
    const result = await execute(() => overenskomsterAPI.listForDepartment());
    if (result.success) setOverenskomster(result.data?.overenskomster ?? []);
    return result;
  }, [execute]);

  const createOverenskomst = useCallback(async (data) => {
    const result = await execute(() => overenskomsterAPI.createOverenskomst(data));
    if (result.success) setOverenskomst(result.data ?? null);
    return result;
  }, [execute]);

  const updateOverenskomst = useCallback(async (overenskomstId, data) => {
    const result = await execute(() => overenskomsterAPI.updateOverenskomst(overenskomstId, data));
    if (result.success) setOverenskomst(result.data ?? null);
    return result;
  }, [execute]);

  const deleteOverenskomst = useCallback(async (overenskomstId) => {
    const result = await execute(() => overenskomsterAPI.deleteOverenskomst(overenskomstId));
    if (result.success) setOverenskomst(null);
    return result;
  }, [execute]);

  const fetchForStaff = useCallback(async (staffMemberId) => {
    const result = await execute(() => overenskomsterAPI.listForStaff(staffMemberId));
    return result;
  }, [execute]);

  const assignStaff = useCallback(async (data) => {
    return execute(() => overenskomsterAPI.assignStaff(data));
  }, [execute]);

  const seedOverenskomster = useCallback(async () => {
    return execute(() => overenskomsterAPI.seedDefaultOverenskomster());
  }, [execute]);

  const fetchActiveAssignmentsForDepartment = useCallback(async () => {
    return execute(() => overenskomsterAPI.listActiveAssignmentsForDepartment());
  }, [execute]);

  return {
    overenskomst,
    overenskomster,
    loading,
    error,
    clearError,
    fetchOverenskomst,
    fetchForDepartment,
    fetchForStaff,
    createOverenskomst,
    updateOverenskomst,
    deleteOverenskomst,
    assignStaff,
    seedOverenskomster,
    fetchActiveAssignmentsForDepartment,
  };
}
